<template>
  <div>
    <stepheader :step="step" />
    <div id="wizard2-p-0" role="tabpanel" aria-labelledby="wizard2-h-0" class="body current" aria-hidden="false"
      style="">
      <div class="row" v-if="isloading">
        <div class="col-12 text-center">
            <span class="spinner-grow spinner-grow-sm"
                  role="status"
                  aria-hidden="true">
            </span>
            Caricamento in corso
        </div>
      </div>
      <div class="row" v-if="!isloading">
        <div class="col-12">
          Verrà aperto un ticket per risolvere il tuo problema.<br>
          Il nostro backoffice verificherà la tua segnalazione e ti indicherà le istruzioni attraverso il ticket
          aperto.<br>
          Ti ricordiamo che tutte le comunicazioni saranno inviate all'interno del ticket che troverai nella tua area
          riservata
          <span v-if="ticket.cliente">La mail associata al tuo contratto è
            <strong>{{ ticket.cliente.emailOperativa }}</strong></span>
          Daremo al corriere l'indirizzo email <strong>{{ indirizzo.email }}</strong> e il telefono
          <strong>{{ indirizzo.telefono }}</strong> per contattarti in caso di necessità durante la consegna del device

        </div>

      </div>

      <buttons v-if="!isloading" :buttons=step.buttons v-on:action="fireaction"></buttons>


    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "riepilogo",

  props: {
    step: {
      type: Object,
      required: true,
    },
    readonly: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    attachments: {
      type: Array,
      required: false,
    },
    ticket: {
      type: Object,
      required: false,
    },
    code: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      indirizzo: null,
      isFired: false,
      isloading: false
    };
  },
  computed: {

  },
  components: {

  },
  mounted() {
    this.indirizzo = this.ticket.logistica.filter(x => x.tipologia == "riconsegna")[0];
  },
  methods: {
    fireaction: function (action, nextstep) {
      switch (action) {
        case "finish":
          if (this.isFired) return;
          this.isFired = true;
          this.isloading = true;
          axios.post("tickets/savewizard", {
            ticket: this.ticket,
            attachments: this.attachments

          }).then(response => {
            this.ticket.codice = response.data.codice;
            this.ticket.idTicket = response.data.idTicket;
            this.isFired = false;
            this.isloading = false;
            this.$emit("goto", nextstep)
          }).catch(e => {
            this.isFired = false;
            swal({
              title: "Errore",
              text: "Ops, qualcosa è andato storto. Si prega di riprovare più tardi",
              type: "error",
              showCancelButton: false,
              toast: false,
              timer: 2000,
              showConfirmButton: false,
              position: "bottom-top",
            });

          })
          // this.$emit("goto",nextstep)
          break;
        default:
          this.$emit("goto", nextstep)
          break;

      }

    },
    loaddata: function () {

    },

    authenticate: function (nextstep) {

    }
  },
};
</script>